import { ModalsProvider } from '@speeki/global-ui-components';
import { IconManager, IconManagerProps } from '@speeki/icons';

import {
    StartToTileWrapper,
    TileDescription,
    TileHeader,
    TileTitle,
} from './StartToModalTile.styled';

interface StartToModalTileProps {
    description: string;
    icon: IconManagerProps['icon'];
    onClick: () => void;
    testId: string;
    title: string;
}

export const StartToModalTile = ({
    description,
    icon,
    onClick,
    testId,
    title,
}: StartToModalTileProps) => {
    const onTileClick = () => {
        onClick();
        ModalsProvider.close('MobileStartToModal');
    };

    return (
        <StartToTileWrapper data-testid={testId} onClick={onTileClick}>
            <TileHeader>
                <IconManager icon={icon} size={24} />
                <TileTitle fontWeight="bold">{title}</TileTitle>
                <IconManager icon={'SvgChevronRight24'} size={24} />
            </TileHeader>
            <TileDescription>{description}</TileDescription>
        </StartToTileWrapper>
    );
};
